import React from "react";
import { Box } from "@mui/material";
import PropTypes from "prop-types";
import LibraryAddOutlinedIcon from "@mui/icons-material/LibraryAddOutlined";
import InlineIconButton from "../../../../../Buttons/InlineIconButton/InlineIconButton";
import StyledTooltip from "../../../../../StyledTooltip/StyledTooltip";

export default function QuickActionsAction({ load, active, actionCallback }) {
  return (
    <StyledTooltip title="Quick Actions">
      <Box>
        <InlineIconButton
          onClick={() => { actionCallback({ action: "quick-actions", loadId: load.orderId || load.id }); }}
          disabled={["AVA", "A-RTGDE", "ONHOLD"].includes(load.brokerageStatus)}
          icon={LibraryAddOutlinedIcon}
          buttonColor={active ? "white" : "blue"}
        />
      </Box>
    </StyledTooltip>
  );
}

QuickActionsAction.propTypes = {
  load: PropTypes.object,
  active: PropTypes.bool,
  actionCallback: PropTypes.func.isRequired
};